import React from "react";
import {
  IoFilter,
  IoChevronDownOutline,
  IoDownloadOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { GrPowerReset } from "react-icons/gr";
import { ViewModeTabs } from "./ViewModeTabs";
import { ViewType } from "../../../constants/enums";

interface ActionButtonsSectionProps {
  activeView: ViewType;
  onFilterClick: () => void;
}

/**
 * Renders the action buttons section including filter, settings, and view mode controls
 */
export const ActionButtonsSection: React.FC<ActionButtonsSectionProps> = ({
  activeView,
  onFilterClick,
}) => {
  const buttonBaseClass =
    "rounded-md border border-gray-300 p-3 shadow-sm hover:border-[#231F20]/10";
  const activeButtonClass = `${buttonBaseClass} hover:bg-primaryPurple-100/20`;
  const disabledButtonClass = `${buttonBaseClass} bg-blue-gray-100/30`;

  return (
    <div className="flex flex-row items-center justify-center gap-3">
      <ActionButton
        onClick={onFilterClick}
        className={activeButtonClass}
        icon={<IoFilter className="text-[#714ECE]" />}
        ariaLabel="Open filters"
      />

      <DisabledActionButton
        icon={<IoSettingsOutline className="text-[#714ECE]" />}
        tooltipText="Coming soon..."
        ariaLabel="Column settings"
      />

      <DisabledActionButton
        icon={<GrPowerReset className="text-[#714ECE]" />}
        tooltipText="Coming soon..."
        ariaLabel="Reset filters"
      />

      <DisabledActionButton
        icon={
          <span className="flex items-center gap-2">
            <IoDownloadOutline className="text-[#714ECE]" />
            <IoChevronDownOutline className="text-[#714ECE]" />
          </span>
        }
        tooltipText="Coming soon..."
        ariaLabel="Download options"
      />

      <ViewModeTabs activeView={activeView} />
    </div>
  );
};

interface ActionButtonProps {
  onClick: () => void;
  className: string;
  icon: React.ReactNode;
  ariaLabel: string;
}

const ActionButton: React.FC<ActionButtonProps> = ({ onClick, className, icon, ariaLabel }) => (
  <button className={className} onClick={onClick} aria-label={ariaLabel}>
    {icon}
  </button>
);

interface DisabledActionButtonProps {
  icon: React.ReactNode;
  tooltipText: string;
  ariaLabel: string;
}

const DisabledActionButton: React.FC<DisabledActionButtonProps> = ({
  icon,
  tooltipText,
  ariaLabel,
}) => (
  <button
    className="has-tooltip relative rounded-md border border-gray-300 bg-blue-gray-100/30 p-3 shadow-sm hover:border-[#231F20]/10"
    aria-label={ariaLabel}
    disabled
  >
    <span className="tooltip text-nowrap left-0 mt-8 rounded bg-gray-100 p-1 text-sm text-primaryPurple-100 shadow-sm">
      {tooltipText}
    </span>
    {icon}
  </button>
);
